import { render, staticRenderFns } from "./Branch_Book_Detail.vue?vue&type=template&id=524b399f"
import script from "./Branch_Book_Detail.vue?vue&type=script&lang=js"
export * from "./Branch_Book_Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports